import React from "react";

import Radio from "@material-ui/core/Radio";
import PropTypes from "prop-types";

import useRbRadioStyles from "./useRbRadioStyles";

const RbRadio = React.forwardRef(function RbRadio(props, ref) {
  const { onChange, onChangeChecked, ...other } = props;

  const classes = useRbRadioStyles(props);

  const handleChange = React.useCallback(
    (event) => {
      if (onChange) {
        onChange(event);
      }
      if (onChangeChecked) {
        onChangeChecked(event.target.checked);
      }
    },
    [onChange, onChangeChecked]
  );

  return (
    <Radio {...other} classes={classes} ref={ref} onChange={handleChange} />
  );
});

RbRadio.propTypes = {
  onChange: PropTypes.func,
  onChangeChecked: PropTypes.func,
};

RbRadio.defaultProps = {
  onChange: undefined,
  onChangeChecked: undefined,
};

export default React.memo(RbRadio);
